import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  type FirestoreRoomStateProfessorFeedback,
  empty,
} from '../firestore/RoomStateProfessorFeedback/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class RoomStateProfessorFeedback extends ObservableModelWithDecorators<FirestoreRoomStateProfessorFeedback> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateProfessorFeedback>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
